import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PhoneCall, Clock, MessageSquare, CheckCircle2, Signal, Wifi, BatteryFull } from "lucide-react";

const STEPS = [
  { status: "+90 WhatsApp numarası alındı", badge: "Numara Tahsis Edildi", color: "#3b82f6", phone: "+90 551 ●●● ●● 84", Icon: PhoneCall, body: "Sanal numara tahsis ediliyor..." },
  { status: "SMS onay kodu bekleniyor", badge: "Bekleniyor", color: "#f59e0b", phone: "+90 551 ●●● ●● 84", Icon: Clock, body: "Kalan süre 19:42" },
  { status: "Onay kodu geldi: 849-201", badge: "Kod Alındı", color: "#10b981", phone: "+90 551 ●●● ●● 84", Icon: MessageSquare, body: "WhatsApp kodunuz: 849-201" },
  { status: "İşlem başarıyla onaylandı!", badge: "Onaylandı", color: "#10b981", phone: "+90 551 ●●● ●● 84", Icon: CheckCircle2, body: "Hesap aktif ✓" },
];

export default function HeroAnimation() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % STEPS.length), 2800);
    return () => clearInterval(t);
  }, []);
  const s = STEPS[i];
  const Icon = s.Icon;
  return (
    <div className="relative anim-float" data-testid="hero-animation">
      <div className="absolute -inset-6 rounded-[3rem] blur-3xl opacity-40" style={{ background: "radial-gradient(circle, rgba(37,99,235,.6), transparent 70%)" }} />
      <div className="relative mx-auto w-[300px] rounded-[2.5rem] border border-white/10 bg-[#101219] p-3 shadow-2xl">
        <div className="rounded-[2rem] overflow-hidden bg-[#0b0d13] border border-white/5">
          {/* status bar */}
          <div className="flex items-center justify-between px-5 pt-3 text-[11px] text-white/70">
            <span className="font-mono">10:31</span>
            <div className="flex items-center gap-1"><Signal size={12} /><Wifi size={12} /><BatteryFull size={14} /></div>
          </div>
          {/* header */}
          <div className="flex items-center gap-3 px-5 py-4 border-b border-white/5">
            <div className="h-9 w-9 rounded-full brand-grad flex items-center justify-center">
              <span className="text-white font-bold">W</span>
            </div>
            <div>
              <div className="text-white text-sm font-semibold">WhatsApp</div>
              <div className="text-white/50 text-[11px]">Doğrulama</div>
            </div>
          </div>
          {/* body */}
          <div className="px-5 py-8 min-h-[280px] flex flex-col items-center justify-center text-center">
            <AnimatePresence mode="wait">
              <motion.div key={i} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -16 }} transition={{ duration: 0.4 }} className="w-full">
                <div className="mx-auto mb-5 h-16 w-16 rounded-2xl flex items-center justify-center pulse-ring" style={{ background: s.color + "22", color: s.color }}>
                  <Icon size={30} />
                </div>
                <div className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-[11px] font-semibold mb-4" style={{ background: s.color + "22", color: s.color }}>
                  <span className="h-1.5 w-1.5 rounded-full blink" style={{ background: s.color }} />
                  {s.badge}
                </div>
                <div className="font-mono text-white text-lg mb-2">{s.phone}</div>
                <div className="text-white/80 text-sm font-medium">{s.status}</div>
                <div className="mt-4 rounded-xl bg-white/5 px-4 py-3 text-white/70 text-xs">{s.body}</div>
              </motion.div>
            </AnimatePresence>
          </div>
          {/* progress dots */}
          <div className="flex items-center justify-center gap-1.5 pb-6">
            {STEPS.map((_, k) => (
              <span key={k} className="h-1.5 rounded-full transition-all duration-500" style={{ width: k === i ? 22 : 6, background: k === i ? "#2563eb" : "rgba(255,255,255,.2)" }} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
